import { OpraReportTemplate } from '@interfaces/report-templates.interface';
import i18n from 'i18next';
import moment from 'moment';
import { SelectWithSearchDataArrayInterface } from '@components/core/select-with-categories/select-with-categories.interface';

export const generateReviewFrequencyUnitOptions = (
    reviewFrequencyNumberMin: number,
    reviewFrequencyNumberMax: number,
    placeholderText?: string,
    ignorePlaceholder?: boolean,
) => {
    const frequencyUnitOptions: SelectWithSearchDataArrayInterface[] = [];
    for (let i = reviewFrequencyNumberMin; i <= reviewFrequencyNumberMax; i++) {
        frequencyUnitOptions.push({
            id: i,
            text: `${i}`,
        });
    }
    if (!ignorePlaceholder)
        frequencyUnitOptions.unshift({
            id: 0,
            text: placeholderText ?? i18n.t('ra:selectReviewFrequencyUnit'),
        });
    return frequencyUnitOptions;
};

export const generateOrgReportTemplateUpdatedField = (item: OpraReportTemplate) => `${i18n.t(
    'reports:templateInUseUpdated',
)}
    ${moment(item.organizationReportTemplateUpdatedDate).utc().format('DD-MMM-YYYY')} ${
        item.organizationReportTemplateUpdatedByName
            ? `${i18n.t('by')} ${item.organizationReportTemplateUpdatedByName}`
            : ''
    }`;

export const generateUpdatedField = (item: any, field: string = 'updated') => `${i18n.t('updated')}
    ${moment(item[field]).utc().format('DD-MMM-YYYY')} ${
        item.updatedBy && typeof item.updatedBy === 'object'
            ? `${i18n.t('by')} ${item.updatedBy.firstName} ${item.updatedBy.lastName}`
            : item.updatedBy && typeof item.updatedBy === 'string'
              ? `${i18n.t('by')} ${item.updatedBy}`
              : item.updatedByName && typeof item.updatedByName === 'string'
                ? `${i18n.t('by')} ${item.updatedByName}`
                : ''
    }`;

export const generateCreatedField = (item: any, field: string = 'created') => `${i18n.t('created')} 
    ${moment(item[field]).utc().format('DD-MMM-YYYY')} ${
        item.createdBy && typeof item.createdBy === 'object'
            ? `${i18n.t('by')} ${item.createdBy.firstName} ${item.createdBy.lastName}`
            : item.createdBy && typeof item.createdBy === 'string'
              ? `${i18n.t('by')} ${item.createdBy}`
              : item.createdByName && typeof item.createdByName === 'string'
                ? `${i18n.t('by')} ${item.createdByName}`
                : ''
    }`;

export const createArrayFromEnum = (
    enumObject: any,
    suffix?: string,
    defaultValue?: string | number | null,
    sort?: (a: any, b: any) => number,
    skipNone: boolean = false,
) => {
    const array: SelectWithSearchDataArrayInterface[] = [];
    const values = Object.values(enumObject);
    if (sort) values.sort(sort);

    values.forEach((item: string | any) => {
        if (skipNone && item === 'NONE') return;

        array.push({
            id: item,
            text: suffix ? i18n.t(`admin:${item}${suffix}`) : i18n.t(`admin:${item}`),
            item,
        });
    });
    array.unshift({
        id: defaultValue !== undefined ? defaultValue : '',
        text: i18n.t('ra:selectValue'),
    });
    return array;
};

export const getFormat = (ignore?: number) => {
    switch (ignore) {
        case 1:
            return 'DD-MMM-YYYY';
        case 2:
            return 'MMM-YYYY';
        default:
            return 'DD-MMM-YYYY H:mm:ss a';
    }
};
